<!-- eslint-disable -->
<template>
    <el-container>
        <el-row class="list-container">
            <el-col :span="24">
                <el-button @click="refreshData" type="primary" size="small" icon="iconfont icon-shuaxin shuaxin">刷新</el-button>
                <el-button type="primary" size="small" icon="iconfont icon-jia shuaxin" @click="dialogFormVisible = true" :disabled="!power.roles_add">新增</el-button>
                <el-button @click="delMultiple" type="danger" size="small" icon="iconfont icon-shanchu shuaxin" :disabled="!power.roles_del">删除</el-button>
            </el-col>

            <el-col class="main-content">
                <el-table :data="dataList" border @selection-change="handleSelectionChange" v-loading="loading" style="width: 100%">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>

                    <el-table-column prop="name" label="角色名称" width="180"></el-table-column>
                    <el-table-column prop="description" label="角色描述" width="250"></el-table-column>
                    <el-table-column prop="status" label="状态" width="100">
                      <template slot-scope="scope">
                      	<el-tag v-if="scope.row.status == 1" type="success">正常</el-tag>
                      	<el-tag v-else type="danger">禁用</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button @click="powerTmp(scope.row)" icon="iconfont icon-quanxian shuaxin" type="warning" size="mini" plain :disabled="!power.roles_add">权限</el-button>
                            <el-button @click="editTmp(scope.row)" icon="iconfont icon-bianji shuaxin" type="primary" size="mini" plain :disabled="!power.roles_add">编辑</el-button>
                            <el-button @click="del(scope.row.id)" icon="iconfont icon-shanchu shuaxin" size="mini" type="danger" plain :disabled="!power.roles_del">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col class="pagination">
                <el-pagination
                	@current-change="changePage"
                  @size-change="changePageSize"
                	background
                  :layout="pageLayout"
                  :page-sizes="pagePageSizes"
                  :page-size="pagePageSize"
                	:total="totalCount"
                  :current-page.sync="current_page"
                	:hide-on-single-page="false">
                </el-pagination>
            </el-col>
        </el-row>

        <!-- 基本信息dialog -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="dialogClose" width="550px" center>
            <el-form :model="form" ref="form" class="dialog-form" @submit.native.prevent>
                <el-form-item label="角色名称"
                    :label-width="formLabelWidth"
                    prop="name"
                    :rules="[
                    { required: true, message: '请输入角色名称', trigger: 'blur' }
                    ]">
                    <el-input type="text" v-model="form.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="角色描述"
                    :label-width="formLabelWidth"
                    prop="description"
                    :rules="[
                    { required: false, message: '请输入角色描述', trigger: 'blur' }
                    ]">
                    <el-input type="textarea" v-model="form.description" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="状态"
                    :label-width="formLabelWidth"
                    prop="status"
                    :rules="[
                    { required: true, message: '请选择状态', trigger: 'blur' }
                    ]">
                    <el-radio v-model="form.status" :label="1" border>正常</el-radio>
                    <el-radio v-model="form.status" :label="2" border>禁用</el-radio>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addData('form')">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 权限dialog -->
        <el-dialog :title="dialogTitlePower" :visible.sync="dialogPower" @close="dialogClosePower" width="650px" :close-on-click-modal="false" center>
            <div v-for="(power, index) in powers" :key="index"
              style="padding-bottom: 10px;">
              <el-checkbox v-model="checkAll[index]" :name="power.route" @change="handleCheckAllChange">{{power.name}}</el-checkbox>
              <div v-for="(children, index2) in power.children" :key="index2">
                <div style="margin: 10px 0;"></div>
                <el-checkbox-group
                  @change="handleCheckChildrenChange(index)"
                  v-model="formPower.power"
                  style="padding-left: 30px;">
                  <el-checkbox v-for="pow in children" :label="pow.route" :key="pow.route">{{pow.name}}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogPower = false">取 消</el-button>
                <el-button type="primary" @click="setRoles">确 定</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>

<!-- eslint-disable -->
<script>
    import {RolesIndex, RolesAdd, RolesDel} from "@/utils/request.js"
    import {mapState} from 'vuex'

    Array.prototype.remove = function(val) {
      var index = this.indexOf(val);
      if (index > -1) {
        this.splice(index, 1);
      }
    }
    export default {
        data(){
            return {
                data: {
                    page: 1,
                    page_size: this.pagePageSize
                },
                loading: false,
                dataList: [],
                totalCount: 0,
                current_page: 1,
                dialogFormVisible: false,
                dialogPower: false,
                loadingAdd: false,
                dialogTitle: "新增角色",
                dialogTitlePower: "",
                formLabelWidth: "120px",
                form: {
                    id: 0,
                    name: "",
                    description: "",
                    status: 1,
                },
                formPower: {
                  id: 0,
                  power: []
                },
                multipleSelection: [],
                powers: [],
                checkAll: []
            }
        },
        created() {
            this.getList()
        },
        computed: mapState(['power']),
        methods: {
            refreshData() {
                this.data.page = 1
                this.current_page = 1
                this.loading = true

                this.getList()
            },
            getList() {
                this.loading = true
                RolesIndex(this.data).then((res) => {
                    if (res.code == 200) {
                        this.data.page++
                        this.dataList = res.data.data
                        this.totalCount = res.data.count
                        this.powers = res.data.powers
                    } else {
                        this.$message.error("数据获取失败!")
                    }
                    this.loading = false
                })
            },
            changePage(page) {
                this.data.page = page
                this.getList()
            },
            changePageSize(size) {
            	this.data.page_size = size
              this.data.page = 1
              this.current_page = 1
            	this.getList()
            },
            addData(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loadingAdd = true
                        RolesAdd(this.form).then((res) => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.dialogFormVisible = false
                                this.data.page--
                                this.getList()
                            } else {
                                this.$message.error(res.msg);
                            }
                            this.loadingAdd = false
                        })
                    }
                });
            },
            editTmp(data) {
                this.form = {
                    id: data.id,
                    name: data.name,
                    description: data.description,
                    status: data.status,
                }
                this.dialogTitle = this.form.id > 0 ? "编辑角色" : "新增角色"
                this.dialogFormVisible = true
            },
            powerTmp(data) {
                this.dialogTitlePower = `权限设置[${data.name}]`
                this.dialogPower = true
                this.formPower = {
                    id: data.id,
                    power: data.power.length > 0 ? data.power.split(',') : []
                }
                for (let i = 0; i < this.powers.length; i++) {
                  if (this.formPower.power.indexOf(this.powers[i].route) > -1) {
                    this.checkAll[i] = true
                  } else {
                    this.checkAll[i] = false
                  }
                }
            },
            dialogClose() {
                this.initForm()
            },
            dialogClosePower() {
                this.formPower = {
                  id: 0,
                  power: []
                }
            },
            initForm() {
                // 初始化，form数据
                this.form = {
                    id: 0,
                    name: "",
                    description: "",
                    status: 1,
                }
                // 重置字段验证
                this.$refs["form"].resetFields();
                this.dialogTitle = "新增角色"
            },
            handleSelectionChange(val) {
                this.multipleSelection = []
                if (val.length > 0) {
                    val.filter((item) => {
                        this.multipleSelection.push(item.id)
                    })
                }
            },
            delMultiple() {
                if (this.multipleSelection.length == 0) {
                    this.$message.error("请至少选择一项你要删除的项");
                    return
                }
                this.del(this.multipleSelection)
            },
            del(id) {
                this.$confirm("确定要执行删除操作吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "error"
                }).then(() => {
                    RolesDel({id: id}).then((res) => {
                        if (res.code == 200) {
                            this.data.page--
                            this.getList()
                            this.$message.success(res.msg);
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {
                    // 取消操作
                });
            },
            setRoles() {
              let postData = {
                id: this.formPower.id,
                power: this.formPower.power.join(',')
              }
              RolesAdd(postData).then((res) => {
                  if (res.code == 200) {
                      this.$message.success(res.msg);
                      this.dialogPower = false
                      this.data.page--
                      this.getList()
                  } else {
                      this.$message.error(res.msg);
                  }
              })
            },
            handleCheckAllChange(val, obj) {
              if (val) {
                this.formPower.power.push(obj.target.name)
              } else {
                this.formPower.power.remove(obj.target.name)
              }

              for (let i = 0; i < this.powers.length; i++) {
                if (this.powers[i].route == obj.target.name) {
                  for (let j = 0; j < this.powers[i].children.length; j++) {
                    for (let z = 0; z < this.powers[i].children[j].length; z++) {
                      let route = this.powers[i].children[j][z].route
                      if (val) {
                        if (this.formPower.power.indexOf(route) < 0) {
                          this.formPower.power.push(route)
                        }
                      } else {
                        if (this.formPower.power.indexOf(route) > -1) {
                          this.formPower.power.remove(route)
                        }
                      }
                    }
                  }
                }
              }
            },
            handleCheckChildrenChange(index) {
              let isHandleList = false
              for (let i = 0; i < this.powers[index].children.length; i++) {
                if (isHandleList) break
                for (let j = 0; j < this.powers[index].children[i].length; j++) {
                  // console.log(this.powers[index].children[i][j].route)
                  if (this.formPower.power.indexOf(this.powers[index].children[i][j].route) > -1) {
                    isHandleList = true
                    break
                  }
                }
              }
              if (isHandleList) {
                this.checkAll[index] = true
                if (this.formPower.power.indexOf(this.powers[index].route) < 0) {
                  this.formPower.power.push(this.powers[index].route)
                }
              } else {
                this.checkAll[index] = false
                if (this.formPower.power.indexOf(this.powers[index].route) > -1) {
                  this.formPower.power.remove(this.powers[index].route)
                }
              }
            }
        }
    }
</script>

<style>
</style>
